import { render, staticRenderFns } from "./NlpWhoIsForIcon3.vue?vue&type=template&id=3142c975"
import script from "./NlpWhoIsForIcon3.vue?vue&type=script&lang=js"
export * from "./NlpWhoIsForIcon3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports